import Api from '../../api/roleApi'
export default {
    state: {
      roles: []
    },
    mutations: {
      ROLES_SET(state, data) {
        state.roles = data;
      },
      ROLES_SET_SELECTED(state, data) {
        if(data === undefined || data.length === undefined || state.roles.length <= 0) return;

        for (let selectedRole of data) {
          let role = state.roles.find(d=>d.id === selectedRole.id);
          role.selected = true;
        }
      }
    },
    actions: {
      ROLE_FETCH(store) {
        Api.fetch().then(response => {
          store.commit('ROLES_SET', response.data);
        }).catch(error => {
          console.error(error);
        })
      },
      ROLE_CREATE(store, item) {
        Api.create(item.data).then(response => {
          store.dispatch('ROLE_FETCH');
          store.dispatch('NOTIFY_MSG', 'auth.notification.edit');
          if(response.status === 200 && item.callBack !== undefined)
            item.callBack();
        }).catch(error => {
          console.error(error);
        })
      },
      ROLE_UPDATE(store, item) {
        Api.update(item.id, item.data).then(response => {
          store.dispatch('ROLE_FETCH');
          store.dispatch('ROLE_UPDATE_CLAIMS', item);
          store.dispatch('NOTIFY_MSG', 'auth.notification.edit');
          if(response.status === 200 && item.callBack !== undefined)
            item.callBack();
        }).catch(error => {
          console.error(error);
        })
      },
      ROLE_DELETE(store, id) {
        Api.delete(id).then(() => {
          store.dispatch('ROLE_FETCH');
        }).catch(error => {
          console.error(error);
        })
      },
      ROLE_UPDATE_CLAIMS(store, data) {
        Api.updateClaims(data.id, data.claims).then(() => {

        }).catch(() => {

        })
      }
    }
}
